import React from 'react'
//import { useQuery } from '@apollo/client';
//import { GET_PUBLICS } from '../../../gql/publication';
import { Button, Icon , Divider } from 'semantic-ui-react';
import "./Plataforma.scss"




   
   

function WhatSend(props) {
const {publication} = props;
   


  return (
    <>
<div className=' plataform'>
{( <>{publication[0].mercado? <a href = {publication[0].mercado}   

target= " _ blank"
  rel="noopener noreferrer"
       >
 <Button color='yellow'> 🤝 Mercado libre   </Button>

</a>
 : <Button color='gray'> No vinculado 😅   </Button>  } </> )}  





{( <>{publication[0].market? <a href = {publication[0].market}   

target= " _ blank"
  rel="noopener noreferrer"
       >
 
 <Button color='facebook'><Icon name='facebook' />Marketplace</Button>
</a>
 : <Button color='gray'>No  vinculado 😅   </Button>  } </> )}  





<Divider/>
<div>   <span> Clic en el boton para ir a la Publicacion </span>                                                                                                           </div>

</div>

</>
    
    
  )
}









export default WhatSend